<template>
    <div class="company__info__container">
        <Card v-bind="options"> 
            <div class="card__container">
                <div class="logo__section">
                    <label class="logo__upload" >
                        <img v-if="data.company_logo.src" :src="data.company_logo.src" :alt="data.company_logo.alt" srcset="">
                        <span v-else>{{data.company_logo.text}}</span>
                        <input type="file" name="logo" hidden  id="logo" @change="upload">
                    </label>
                    <p class="info__description" v-html="data.company_logo.info_description"></p>
                </div>
                <div class="form__section">
                    <span>{{data.form.title}}</span>
                    <form @submit.prevent="save">
                        <div class="field__container" v-for="(item,index) in data.form.elements" :key="index" :style="`width:${item.width}`">
                            <components :is="item.component" v-bind="Object.assign(item,{width: null })" v-model="company[item.name]" />
                        </div>
                        <div class="form_btns">
                            <Button v-bind="data.form.submit_btn"></Button>
                        </div>
                    </form>
                </div>
            </div>
        </Card>
    </div>


</template>

<script>
    import Card from '../../../components/global/Card.vue';
    import Input from '../../../components/global/Input.vue';
    import Button from '../../../components/global/Button.vue';
    import Select from '../../../components/global/Select.vue';
    import CheckBox from '../../../components/global/CheckBox.vue';
    export default {
        components : { Card, Input, Button, Select, CheckBox },
        data(){
            return {
                company: {},
                options :{
                    padding : { x : 0, y : 0},
                    rounded : .3,
                    boxShadow : {x : 5, y : 5, blur : 1, color : '#e5e5e526'},
                    hasfooter : false,
                    hasHeader : false,
                    boxShadow : { x : 1, y : 3, blur : 5, color : "#ccc"},         
                    bordered : false,
                    main : { 
                        padding : { x : 0, y : 0},
                    },
                },
                data :{
                    company_logo : {
                        text : "upload your logo here",
                        info_description:"Select the logo image you'd like to use from your computer files.</br>",
                        src :"",
                        alt : "comapny logo"
                    },
                    form : {
                        title : "Company details",
                        elements : [
                                    {
                                        label : "Company name",
                                        type : "text",
                                        name:"name",
                                        required : true,
                                        hint : "",
                                        padding : { x : .7, y : .5},
                                        width : "50%",
                                        component : "Input"
                                    },
                                    {
                                        label : "Email",
                                        type : "email",
                                        name:"email",
                                        required : true,
                                        hint : "",
                                        padding : { x : .7, y : .5},
                                        width : "50%",
                                        component : "Input"
                                    },
                                
                                    {
                                        label : "Code",
                                        type : "text",
                                        name:"code",
                                        hint : "+1",
                                        padding : { x : .7, y : .5},
                                        width : "8%",
                                        component : "Input"
                                    },
                                    {
                                        label : "contact Number",
                                        type : "tel",
                                        type:"contact_number",
                                        required : true,
                                        hint : "",
                                        padding : { x : .7, y : .5},
                                        width : "42%",
                                        component : "Input"
                                    },
                                
                                  
                                    {
                                        label : "Web Url",
                                        type : "url",
                                        name:"web_url",
                                        hint : "www.exemple.com",
                                        padding : { x : .7, y : .5},
                                        width : "50%",
                                        component : "Input"
                                    },
                                    {
                                        placeholder : "select country",
                                        options : [],
                                        name:"country",
                                        padding : { x : .7, y : .65},
                                        width : "25%",
                                        margin : 0,
                                        component : "Select"
                                    },
                                    {
                                        label : "City",
                                        type : "text",
                                        name:"city",
                                        required : true,
                                        hint : "",
                                        padding : { x : .7, y : .5},
                                        width : "25%",
                                        component : "Input"
                                    },
                                    {
                                        label : "state",
                                        type : "text",
                                        name:"state",
                                        required : true,
                                        hint : "",
                                        padding : { x : .7, y : .5},
                                        width : "25%",
                                        component : "Input"
                                    },
                                    {
                                        label : "Zip code",
                                        type : "text",
                                        name:"zip_code",
                                        required : true,
                                        hint : "",
                                        padding : { x : .7, y : .5},
                                        width : "25%",
                                        component : "Input"
                                    },
                                    {
                                        label : "street address",
                                        type : "text",
                                        name:"street_address",
                                        required : true,
                                        hint : "",
                                        padding : { x : .7, y : .5},
                                        width : "100%",
                                        component : "Input"
                                    },
                                    {
                                        label : "Description",
                                        type : "text",
                                        name:"description",
                                        multiline : 4,
                                        hint : "",
                                        padding : { x : .7, y : .5},
                                        width : "100%",
                                        component : "Input"
                                    },
                                    {
                                        text : "I agree to the Terme of Use and Privacy Policy",
                                        id : "privacy_policy",
                                        name : "privacy_policy",
                                        borderColor : '#fff',
                                        fillColor:"#343B43",
                                        check : false,
                                        width : "100%",
                                        component : "CheckBox"
                                    },
                        ],
                        submit_btn : {
                                        name : "SAVE & CONTINUE",
                                        type : "submit",
                                        backgroundColor : "#7367f0",
                                        width : "100%",
                                        component : "Button"
                        }
                    }
                }
            }
        },
        methods : {
            upload(e) {
                let file = e.target.files[0]
                let reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = (e) => {
                    this.company.logo = this.data.company_logo.src = e.target.result;
                };
            },
            save(){
                console.log(this.company);
                }
        }
    }
</script>

<style lang="scss" scoped>
    .card__container {
        // position:relative;
        // bottom : 6rem;
        display: flex;
        flex-direction: row-reverse;
    }
    .logo__section {
        position:relative;
        display :flex;
        align-items :center;
        flex-direction: column;
        background-color : #fff;
        padding: 2rem;
     
       
        p {
            padding : 0.5rem 0;
            color : #0000005d;
            font-size: .9rem;
        }
    }
    .logo__upload {
        // position:absolute;
        border: 1px solid #E2E6F1;
        border-radius: 50%;
        background-color: #F2F3F7;
        width : 13rem;
        height : 13rem;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &:hover {
            opacity :.8;
        }
        span  {
            color:#343B43;
            font-weight: 500;
            font-size: 1.4rem;
            padding : 0 1rem;
            text-transform: uppercase;
            text-align: center;
        }
        img {
            width : 100%;
            height : 100%;
            object-fit: cover;
            border-radius: 50%;
        }
    }
    .form__section {
        padding : 3rem;
        form {
            display : flex;
            flex-wrap: wrap;
        }
        span:first-child {
            font-size: 1.4rem;
            font-weight: 500;
            text-transform: uppercase;
        }
    }
    .field__container {
        padding : .2rem .5rem;
        display : flex;
        align-items: flex-end;
        div {
            width : 100%;
        }
    }
    .inner {
        label {
            font-size: .5rem !important;
        }
    }
    .form_btns {
        width : 100%;
        display : flex;
        justify-content : flex-end;
        button {
            width : fit-content !important;
        }
    }
     @media screen and (max-width: 768px) {
         .field__container {
             width : 100% !important;
         }
         .form_btns {
             padding : 0 !important;
         }
     }
</style>


// WEBPACK FOOTER //
// src/views/user_profile/company/companyInfo.vue